import React from "react";

const Logo = ({ className = "", variant = "default" }) => {
  const isLight = variant === "light";
  const isDark = variant === "dark";
  
  return (
    <div className={`flex flex-col items-center gap-1 ${className}`}>
      {/* Logo Icon - Larger */}
      <div className="relative">
        <div className={`w-16 h-16 rounded-lg overflow-hidden ${
          isLight ? "bg-white" : isDark ? "bg-gray-900" : "bg-gradient-to-br from-blue-600 to-blue-800"
        } flex items-center justify-center shadow-lg`}>
          <div className="relative">
            {/* M Letter with floor lines effect */}
            <svg width="44" height="44" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4 26V10L10 16L16 10L22 16L28 10V26"
                stroke={isLight ? "#1e40af" : isDark ? "#3b82f6" : "white"}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4 20H28M4 24H28"
                stroke={isLight ? "#1e40af" : isDark ? "#3b82f6" : "white"}
                strokeWidth="1.5"
                strokeOpacity="0.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>
      </div>
      
      {/* Brand Text - Below Icon */}
      <div className="flex flex-col items-center leading-tight">
        <span className={`text-sm font-bold tracking-tight ${
          isLight ? "text-white" : isDark ? "text-gray-900" : "text-gray-900"
        }`}>
          Manuel Epoxy
        </span>
        <span className={`text-xs font-medium tracking-wider ${
          isLight ? "text-blue-200" : isDark ? "text-gray-600" : "text-blue-600"
        }`}>
          FLOORS
        </span>
      </div>
    </div>
  );
};

export default Logo;
